const SENTRY_ORGANIZATION   = 'magnitt-hq';

// for server-side rendering
const SENTRY_PROJECT_SERVER = 'magnitt-content-server-side';
const SENTRY_DSN_SSR = 'https://9f516a81e5a07026c3caa64ef54ba8ab@o4506931166838784.ingest.us.sentry.io/4507406787543040';

// for client-side rendering
const SENTRY_PROJECT_CLIENT = 'magnitt-content-client-side';
const SENTRY_DSN_CSR = 'https://b6e8a4bddd26f7a9e8f5e100f2685699@o4506931166838784.ingest.us.sentry.io/4507406789443584';

// errors that should not be tracked in sentry
const SENTRY_ERRORS_TO_IGNORE = [
    /Network Error/i,
    /Request aborted/i, // network issues / timeout / left page
    /Timeout/i,
    // errors from Outlook web crawler 'Safe Links' feature
    // https://forum.sentry.io/t/unhandledrejection-non-error-promise-rejection-captured-with-value/14062/38
    // https://github.com/getsentry/sentry-javascript/issues/3440
    "Non-Error promise rejection captured with value: Object Not Found Matching Id:5, MethodName:update, ParamCount:4",
    "Non-Error promise rejection captured with value: Object Not Found Matching Id:5, MethodName:simulateEvent, ParamCount:1",
    // no stack trace possible when the rejection value itself carries no info (usually a third-party embed/extension)
    "Non-Error promise rejection captured with value: null",
    "Non-Error promise rejection captured with value: undefined",
    // react-helmet (unmaintained) can flush its DOM update after the tab is torn down (navigation away, bfcache), when document.head is already gone
    // phrasing varies by engine: V8 "Cannot read properties of null (reading 'querySelectorAll')" vs WebKit "can't access property \"querySelectorAll\", n is null"
    /^(?=.*querySelectorAll)(?=.*\bnull\b).*$/i
]

module.exports = {
    SENTRY_ORGANIZATION,
    SENTRY_PROJECT_SERVER,
    SENTRY_PROJECT_CLIENT,
    SENTRY_DSN_SSR,
    SENTRY_DSN_CSR,
    SENTRY_ERRORS_TO_IGNORE
};